module.exports = __webpack_public_path__ + "img/chara_5.cbcbb1e7.png";